import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import AcceptedLeadView from '../components/accepted-lead-view';
import OpportunityView from '../components/opportunity-view';
import InvalidLeadView from '../components/invalid-lead-view';
import Loader from '../components/loader';
import closeModal from '../actions/CloseModal';
import BaseModal from '../components/BaseModal';

class Modal extends React.Component {
  constructor(props) {
    super(props);
    this.closeModal = this.closeModal.bind(this);
  }

  componentDidMount() {
    document.body.classList.toggle('product-modal', this.props.modal.state !== 'off');
  }

  componentDidUpdate(prevProps) {
    // Check if modal state has changed and toggle body class accordingly
    if (prevProps.modal.state !== this.props.modal.state) {
      document.body.classList.toggle('product-modal', this.props.modal.state !== 'off');
    }
  }

  componentWillUnmount() {
    document.body.classList.remove('product-modal');
  }

  closeModal() {
    this.props.closeModal(this.props.modal.type);
  }

  render() {
    let content = '';

    switch (this.props.modal.type) {
      case 'accepted-lead-view':
        content = <AcceptedLeadView lead={this.props.modal.data} onClose={this.closeModal} />;
        break;
      case 'opportunity-lead-view':
        content = <OpportunityView lead={this.props.modal.data} onClose={this.closeModal} />;
        break;
      case 'invalid-lead-view':
        content = <InvalidLeadView lead={this.props.modal.data} onClose={this.closeModal} />;
        break;
      default:
        content = <div />;
    }

    return (
      <div>
        <BaseModal open={this.props.modal.state !== 'off'} onClose={this.closeModal}>
          {content}
        </BaseModal>
      </div>
    );
  }
}

Modal.propTypes = {
  modal: PropTypes.object.isRequired,
  closeModal: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  modal: state.modal,
});

const mapDispatchToProps = dispatch => ({
  closeModal: (modalType) => dispatch(closeModal(modalType)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Modal);
